import { Record } from 'immutable';

import { UserOrganization } from '../domain/user-organization';
import { UserPreference } from '../domain/user-preference';
import { UserProfile } from '../domain/user-profile';

export const CORE = 'core';

export interface IAppRootState {
	[CORE]: CoreState;
}

interface ICoreState {
	selectedOrganization: number;
	organization: UserOrganization;
	connectedUser: UserProfile;
	userPreference: UserPreference;
}

const stateDefaults: ICoreState = {
	selectedOrganization: -1,
	organization: UserOrganization.DefaultValue(),
	connectedUser: UserProfile.build(),
	userPreference: UserPreference.build(),
};

export class CoreState extends Record<ICoreState>(stateDefaults) {
	public setSelectedOrganization(val: number): CoreState {
		return this.set('selectedOrganization', val);
	}

	public setOrganization(val: UserOrganization): CoreState {
		return this.set('organization', val);
	}
	public setConnectedUser(val: UserProfile): CoreState {
		return this.set('connectedUser', val);
	}

	public setUserPreference(val: UserPreference): CoreState {
		return this.set('userPreference', val);
	}
}
